export default __webpack_public_path__ + "static/media/alerts-light.ed9ab654.svg";